module.exports = __webpack_public_path__ + "static/media/jessica.a0d51cd0.png";